<template>
    <div>
        <div>
            <div class="greybox">
                <h1>Your claim has been APPROVED!</h1>

                <p>Your claim reference number is: <strong>{{claimReference}}</strong></p>
                <p>Click <strong>Next</strong> to select a repair option for your gadget.</p>
                <p><strong>Please note:</strong> You will be asked to log on if you have not already done so.  
                We have sent your log in details via email.</p>
                <p>You can also contact the claims team on  {{resellerInfo.telephone}} during office hours</p>
                <button class="button mt-3" @click="handleNextClick('claims')">Next</button>
            </div>
        </div>     
    </div>
</template>

<script>

import standaloneClaimForm from '@/mixins/standaloneClaimForm'

export default {
  name: 'thankyou',
  mixins: [
    standaloneClaimForm
  ],
  data () {
    return {
      resellerInfo: require('../../assets/theme/' + process.env.VUE_APP_RESELLER_ID + '/reseller.json'),
      gadgetId: null
    }
  },
  beforeMount () {
    let { submissionResponse } = this.$store.state.claimform
    if (submissionResponse) {
      this.gadgetId = submissionResponse.gadgetId
    }
  },
  mounted () {

  },
  computed: {
    claimReference () {
      if (this.$store.state.claimform.submissionResponse) {
        return this.$store.state.claimform.submissionResponse.claimReference
      }

      return ''
    },
    formRef () {
      if (this.$store.state.claimform.submissionResponse) {
        return this.$store.state.claimform.submissionResponse.claimId
      }

      return ''
    },
    incidentTypeId () {
      if (this.$store.state.claimform.submissionResponse) {
        return this.$store.state.claimform.submissionResponse.incidentType.Id
      }

      return 0
    }
  },
  methods: {
    handleNextClick (url) {
    //   if (url === 'claims') {
    //     this.$router.push({ path: '/myclaims/list' })
    //   } else if (url === 'docs') {
    //     this.$router.push({ path: '/myclaims/supportingdocs' })
    //   }
      if (this.gadgetId != null) {
        this.$router.push({ path: '/myclaims/repairoptions/list/' + this.gadgetId })
      } else {
        this.router.push({ path: '/myclaims/list' })  
      }
    }
  }
}
</script>

<style scoped>
</style>
